module.exports = __webpack_public_path__ + "img/logo_full.e2b9a1c5.svg";